$(document).ajaxError(function(event, jqxhr, settings, thrownError) {
	var servletLocation = '/web/nniprestserviceservlet/';
	
	//	Only run this on the frontend of the site
	if(typeof(inContextMode) === 'undefined') {
		var page = getRedirectPage(jqxhr.status);
		
		if(jqxhr.status === 419){
			logout();
		}
		
		if(jqxhr.status === 521){
			if(typeof(page) !== 'undefined'){
				$.get(servletLocation + 'logout', function(data) {
					window.location = page;
				});
			}else{
				logout();
			}		
		}
	}
 
    // Pension Details Call
	if(settings.url === servletLocation + 'pensionDetails'){
		if($('form[name=ppform]').length > 0) $('form[name=ppform]').closest('.content').html('<p>' + jsLanguageLabel.genericpperror + '</p>');
	}
	
	// Pension Overview Call
	if((servletLocation + 'getPensionOverview').indexOf(settings.url) !== -1){
		if($('#pensionPlannerOverview').length > 0) $('#pensionPlannerOverview').html('<p>' + jsLanguageLabel.genericpperror + '</p>');
	}
	
	/*if((servletLocation + 'calculateExpenses').indexOf(settings.url)){
	    logout();
	}*/
	
	function logout(){
		// Trigger our logout, then redirect to home
		$.get(servletLocation + 'logout', function(data) {
			window.location = '/';
		});
	}
	
	function getRedirectPage(statusCode){
		return specialErrorPages[statusCode];
	}
	
});